import { useContext } from "react";
import { useDraggable } from "@dnd-kit/core";
import { RowDragOutContext } from "./rowDragOut";
import {
    ViewTableRowComponent,
    type ViewTableRowComponentProps,
} from "./ViewTableRow";

const NO_DRAG_DATA = {};

/**
 * A row that drags out of the table from anywhere on it (see `rowDragOut`).
 * Pointer-only: the dnd-kit attributes would make the row a button, so the
 * row checkbox and the bulk action stay the keyboard path.
 */
export function ViewTableDragOutRow<TData extends { id: string | number }>(
    props: ViewTableRowComponentProps<TData>,
) {
    const context = useContext(RowDragOutContext);
    const data = context?.getRowDragData(props.row.id) ?? null;
    const { listeners, setNodeRef } = useDraggable({
        id: `row-drag-out:${context?.tableId ?? ""}:${props.row.id}`,
        data: data ?? NO_DRAG_DATA,
        disabled: data === null,
    });
    return (
        <ViewTableRowComponent {...props} dragOut={{ setNodeRef, listeners }} />
    );
}
